import { Button, Flex, Modal, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SettingProjectAddTaskModal = ({
    isModalOpen,
    onCancel = () => { },
    onSubmit = () => { },
    taskOption = [],
    taskOnEdit = {},
    isView = false,
    roleOption = [],
    onRoleChange = () => { },
    selectedRoleId
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm();

    useEffect(() => {
        if (taskOnEdit) {
            form.setFieldsValue({ ...taskOnEdit, underTaskId: taskOnEdit?.underTaskId, roleId: taskOnEdit?.role?.roleId || selectedRoleId })
        }

    }, [taskOnEdit, form])

    return (
        <Modal
            open={isModalOpen}
            closable={false}
            maskClosable={false}
            footer={false}
            width={620}
        >
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <h3>{t("setting_timesheet.label.add_new_task")}</h3>
                    <span style={{ color: "#667085" }}>{t("setting_timesheet.label.detail")}</span>
                </Flex>

                <FormAntd
                    form={form}
                    onFinish={(values) => {
                        let action = values?.id ? "EDIT" : "ADD"
                        let label = action === "EDIT" ? (i18n.language === 'en' ? "Are you sure you want to edit task to this role?" : "ยืนยันการแก้ไขงานนี้หรือไม่")
                            : (i18n.language === 'en' ? "Are you sure you want to add task to this role?" : "ยืนยันการเพิ่มงานเข้าในบทบาทนี้หรือไม่")
                        Modal.confirm({
                            title: t("dialog.confirmation.header"),
                            content: label,
                            onOk() {
                                onSubmit(values)
                                form.resetFields();
                            },
                            okText: t("common.confirm"),
                            cancelText: t("common.cancel"),
                        });

                    }}

                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldsValue, getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                    <FormSelect
                                        name="roleId"
                                        label={t("role.header")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        options={roleOption}
                                        disabled={isView}
                                        required
                                        onChange={(value) => {
                                            setFieldValue("underTaskId", undefined);
                                            onRoleChange(value);
                                        }}
                                    />
                                    <FormInput
                                        name="taskName"
                                        label={t("setting_timesheet.label.taskName")}
                                        placeholder={t("common.please_fill")}
                                        size="large"
                                        required
                                        disabled={isView}
                                    />
                                    <FormInput
                                        name="taskNameEn"
                                        label={t("setting_timesheet.label.taskNameEn")}
                                        placeholder={t("common.please_fill")}
                                        size="large"
                                        required
                                        disabled={isView}
                                    />
                                    <FormSelect
                                        name="underTaskId"
                                        label={t("setting_timesheet.label.underTask")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        options={taskOption}
                                        disabled={isView}
                                        allowClear
                                    />
                                    <Flex gap={8} justify="end">
                                        {
                                            !isView ? (
                                                <>
                                                    <Button
                                                        type="default"
                                                        style={{ borderRadius: "8px", height: "40px", color: "#565656", fontWeight: "bold" }}
                                                        onClick={() => {
                                                            onCancel()
                                                            form.resetFields()
                                                        }}
                                                    >
                                                        {t("common.cancel")}
                                                    </Button>

                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color", fontWeight: "bold" }}
                                                    >
                                                        {t("common.save")}
                                                    </Button>
                                                </>
                                            ) : (
                                                <>
                                                    <Button
                                                        type="default"
                                                        style={{ borderRadius: "8px", height: "40px", color: "#565656", fontWeight: "bold" }}
                                                        onClick={() => {
                                                            onCancel()
                                                            form.resetFields()
                                                        }}
                                                    >
                                                        {t("common.close")}
                                                    </Button>
                                                </>
                                            )
                                        }

                                    </Flex>
                                </Space>
                            )
                        }}
                    </FormItem>
                </FormAntd>


            </Space>
        </Modal>
    )
}

export default SettingProjectAddTaskModal;